import './Layer.scss';

class Layer {
  button = null;
  element = null;

  constructor(){
    this.element =  document.getElementsByClassName('layer')[0];
    this.button = document.getElementsByClassName('layer--close')[0];

    if(this.button){
      this.button.addEventListener('click', ()=> this.onClose());
    }
  }

  onClose() {
    this.element.classList.add('hide');;
  }
}


export default Layer;


// WEBPACK FOOTER //
// ./src/components/layer/Layer.js